export const categories = [
  { id: "rexue", name: "热血", icon: "ri-fire-fill" },
  { id: "dushi", name: "都市", icon: "ri-building-2-fill" },
  { id: "xuanhuan", name: "玄幻", icon: "ri-sparkling-2-fill" },
  { id: "kehuan", name: "科幻", icon: "ri-rocket-2-fill" },
  { id: "xuanyi", name: "悬疑", icon: "ri-moon-foggy-fill" },
  { id: "xiaoyuan", name: "校园", icon: "ri-school-fill" },
  { id: "gufeng", name: "古风", icon: "ri-landscape-fill" },
  { id: "meishi", name: "美食", icon: "ri-restaurant-fill" },
  { id: "jijia", name: "机甲", icon: "ri-robot-2-fill" },
  { id: "yijie", name: "异能", icon: "ri-magic-fill" },
  { id: "tuili", name: "推理", icon: "ri-search-eye-fill" },
  { id: "manhua", name: "国漫", icon: "ri-flag-fill" },
];

export const comics = [
  {
    id: "jianqi-canglan",
    title: "剑起沧澜",
    category: "热血",
    categoryId: "rexue",
    status: "连载中",
    score: "9.6",
    readers: "128万",
    chapter: "第 258 话",
    tags: ["武侠", "热血", "逆袭"],
    cover: "https://readdy.ai/api/search-image?query=a%20young%20swordsman%20standing%20on%20a%20stormy%20mountain%20peak%20with%20a%20glowing%20long%20sword%2C%20dynamic%20ink%20wash%20chinese%20fantasy%20illustration%2C%20dramatic%20clouds%20and%20lightning%2C%20epic%20composition%2C%20rich%20teal%20and%20orange%20contrast%2C%20manga%20cover%20art&width=640&height=900&seq=mm-comic-jianqi&orientation=portrait",
    desc: "少年陆沧生于江湖动荡之世，为寻父辈之谜踏入腥风血雨的武林，凭一柄残剑逆势崛起，揭开尘封百年的剑道秘辛。",
  },
  {
    id: "dushi-yinlong",
    title: "都市隐龙",
    category: "都市",
    categoryId: "dushi",
    status: "连载中",
    score: "9.3",
    readers: "96万",
    chapter: "第 342 话",
    tags: ["都市", "强强", "爽文"],
    cover: "https://readdy.ai/api/search-image?query=a%20confident%20young%20man%20in%20a%20sharp%20modern%20suit%20standing%20in%20front%20of%20a%20city%20skyline%20at%20dusk%2C%20urban%20manga%20cover%20illustration%2C%20cool%20blue%20and%20warm%20orange%20city%20lighting%2C%20dramatic%20pose%2C%20comic%20art&width=640&height=900&seq=mm-comic-yinlong&orientation=portrait",
    desc: "隐姓埋名的顶级特工回归都市，本以为能过上平淡生活，却在一次次的阴谋与算计中，重新搅动整个城市的风云。",
  },
  {
    id: "xingji-lvren",
    title: "星际旅人",
    category: "科幻",
    categoryId: "kehuan",
    status: "连载中",
    score: "9.1",
    readers: "74万",
    chapter: "第 189 话",
    tags: ["星际", "冒险", "太空歌剧"],
    cover: "https://readdy.ai/api/search-image?query=a%20lone%20space%20pilot%20floating%20in%20front%20of%20a%20colossal%20nebula%20with%20glowing%20starships%2C%20space%20opera%20manga%20cover%2C%20vibrant%20purple%20and%20magenta%20nebula%20colors%2C%20sense%20of%20wonder%2C%20sci-fi%20comic%20art&width=640&height=900&seq=mm-comic-xingji&orientation=portrait",
    desc: "跨越星系而行的流浪旅人，在探索未知文明与古老遗迹的旅途中，逐渐揭开了人类起源与宇宙深空隐藏的巨大秘密。",
  },
  {
    id: "linghu-zhuan",
    title: "灵狐传",
    category: "玄幻",
    categoryId: "xuanhuan",
    status: "连载中",
    score: "9.5",
    readers: "103万",
    chapter: "第 221 话",
    tags: ["玄幻", "仙侠", "妖灵"],
    cover: "https://readdy.ai/api/search-image?query=a%20mystical%20nine-tailed%20fox%20spirit%20girl%20in%20flowing%20traditional%20robes%20surrounded%20by%20glowing%20fox%20spirits%2C%20chinese%20fantasy%20xianxia%20manga%20cover%2C%20ethereal%20mist%2C%20soft%20pink%20and%20gold%20lighting%2C%20beautiful%20detailed%20art&width=640&height=900&seq=mm-comic-linghu&orientation=portrait",
    desc: "修行千年的白狐少女化形入世，为报前世之恩踏入修真界，在恩怨情仇与天道轮回间，寻回自己的仙缘与初心。",
  },
  {
    id: "yiwu-shuangjue",
    title: "医武双绝",
    category: "都市",
    categoryId: "dushi",
    status: "连载中",
    score: "9.0",
    readers: "68万",
    chapter: "第 274 话",
    tags: ["都市", "医道", "武道"],
    cover: "https://readdy.ai/api/search-image?query=a%20calm%20young%20physician%20holding%20acupuncture%20needles%20with%20a%20subtle%20martial%20aura%20around%20him%2C%20modern%20chinese%20urban%20fantasy%20manga%20cover%2C%20jade%20green%20and%20warm%20tones%2C%20elegant%20detailed%20art&width=640&height=900&seq=mm-comic-yiwu&orientation=portrait",
    desc: "身怀绝世医术与神秘内功的青年，以凡人之躯行走都市，救人于危难之间，也在一次次博弈中重写属于自己的命运。",
  },
  {
    id: "yushou-ji",
    title: "御兽师纪",
    category: "玄幻",
    categoryId: "xuanhuan",
    status: "已完结",
    score: "9.2",
    readers: "87万",
    chapter: "全 486 话",
    tags: ["御兽", "成长", "热血"],
    cover: "https://readdy.ai/api/search-image?query=a%20young%20beast-tamer%20standing%20beside%20a%20majestic%20fantasy%20dragon%20companion%2C%20epic%20creature%20world%20manga%20cover%2C%20lush%20green%20and%20gold%20palette%2C%20dynamic%20action%2C%20fantasy%20comic%20art&width=640&height=900&seq=mm-comic-yushou&orientation=portrait",
    desc: "在一个人与灵兽共存的世界里，少年御兽师从最弱小的见习者起步，与伙伴灵兽并肩作战，一步步登上御兽大陆之巅。",
  },
  {
    id: "anye-lieshou",
    title: "暗夜猎手",
    category: "悬疑",
    categoryId: "xuanyi",
    status: "连载中",
    score: "9.4",
    readers: "79万",
    chapter: "第 167 话",
    tags: ["悬疑", "都市", "推理"],
    cover: "https://readdy.ai/api/search-image?query=a%20hooded%20detective%20figure%20standing%20in%20a%20dark%20rainy%20alley%20with%20neon%20lights%20and%20mysterious%20shadows%2C%20dark%20suspense%20manga%20cover%2C%20moody%20blue%20and%20red%20lighting%2C%20noir%20atmosphere%2C%20comic%20art&width=640&height=900&seq=mm-comic-anye&orientation=portrait",
    desc: "专门处理超自然悬案的神秘猎手，在霓虹交织的城市夜幕下，追查一桩桩离奇案件背后的真相与不为人知的黑暗。",
  },
  {
    id: "xiaoyuan-qiqi",
    title: "校园奇缘",
    category: "校园",
    categoryId: "xiaoyuan",
    status: "连载中",
    score: "9.0",
    readers: "62万",
    chapter: "第 158 话",
    tags: ["校园", "恋爱", "青春"],
    cover: "https://readdy.ai/api/search-image?query=a%20vibrant%20high%20school%20romance%20scene%20with%20cherry%20blossoms%20and%20two%20students%20under%20a%20tree%2C%20youthful%20school%20manga%20cover%2C%20soft%20pink%20and%20cream%20palette%2C%20fresh%20sweet%20atmosphere%2C%20romance%20comic%20art&width=640&height=900&seq=mm-comic-xiaoyuan&orientation=portrait",
    desc: "转学生与同桌之间从互不顺眼到渐生情愫的青春物语，校园生活里那些细碎又闪闪发光的日子，都写进了漫画里。",
  },
  {
    id: "shanhe-huijuan",
    title: "山河绘卷",
    category: "古风",
    categoryId: "gufeng",
    status: "连载中",
    score: "9.5",
    readers: "91万",
    chapter: "第 203 话",
    tags: ["古风", "权谋", "江湖"],
    cover: "https://readdy.ai/api/search-image?query=a%20scholar-warrior%20in%20ancient%20chinese%20robes%20overlooking%20a%20vast%20misty%20landscape%20with%20pagodas%20and%20rivers%2C%20wuxia%20manga%20cover%2C%20elegant%20ink%20and%20wash%20colors%2C%20traditional%20chinese%20aesthetic%2C%20detailed%20art&width=640&height=900&seq=mm-comic-shanhe&orientation=portrait",
    desc: "一幅可绘山河社稷的神秘画卷，引动庙堂与江湖的双重风波。少年以笔为剑，在朝野纷争中勾勒属于自己的天下。",
  },
  {
    id: "shiji-zhan",
    title: "食戟之战",
    category: "美食",
    categoryId: "meishi",
    status: "连载中",
    score: "9.2",
    readers: "70万",
    chapter: "第 236 话",
    tags: ["美食", "竞技", "热血"],
    cover: "https://readdy.ai/api/search-image?query=a%20dynamic%20cooking%20battle%20scene%20with%20steaming%20gourmet%20dishes%20and%20energy%20sparks%2C%20culinary%20manga%20cover%2C%20rich%20warm%20food%20colors%2C%20dramatic%20chef%20pose%2C%20vibrant%20comic%20art&width=640&height=900&seq=mm-comic-shiji&orientation=portrait",
    desc: "顶级厨师学园里的食戟对决，一桌佳肴即是一场没有硝烟的战争。少年天才以味觉征服评委，也重新定义料理的意义。",
  },
  {
    id: "jijia-jiyuan",
    title: "机甲纪元",
    category: "机甲",
    categoryId: "jijia",
    status: "已完结",
    score: "9.3",
    readers: "82万",
    chapter: "全 512 话",
    tags: ["机甲", "科幻", "战争"],
    cover: "https://readdy.ai/api/search-image?query=a%20massive%20battle%20mech%20robot%20standing%20in%20a%20burning%20warzone%20under%20an%20orange%20sky%2C%20mecha%20manga%20cover%2C%20industrial%20metal%20details%2C%20dramatic%20action%2C%20sci-fi%20comic%20art&width=640&height=900&seq=mm-comic-jijia&orientation=portrait",
    desc: "战火纷飞的机甲时代，天才驾驶员驾驶最先进的机甲驰骋疆场，在国与国、机与机的较量中守护最后的人类火种。",
  },
  {
    id: "yuanjie-shizhe",
    title: "元界使者",
    category: "异能",
    categoryId: "yijie",
    status: "连载中",
    score: "9.1",
    readers: "66万",
    chapter: "第 178 话",
    tags: ["异能", "都市", "战斗"],
    cover: "https://readdy.ai/api/search-image?query=a%20heroic%20young%20man%20emitting%20glowing%20elemental%20powers%20with%20light%20particles%20swirling%20around%2C%20superpower%20battle%20manga%20cover%2C%20electric%20cyan%20and%20gold%20energy%2C%20dynamic%20motion%2C%20comic%20art&width=640&height=900&seq=mm-comic-yuanjie&orientation=portrait",
    desc: "获得神秘元力的平凡青年，一夜之间成为掌控元素力量的使者，在守护城市与对抗异族入侵之间踏上英雄之路。",
  },
  {
    id: "yexing-shentan",
    title: "夜行神探",
    category: "推理",
    categoryId: "tuili",
    status: "连载中",
    score: "9.4",
    readers: "72万",
    chapter: "第 196 话",
    tags: ["推理", "悬疑", "犯罪"],
    cover: "https://readdy.ai/api/search-image?query=a%20sharp-eyed%20detective%20holding%20a%20magnifying%20glass%20surrounded%20by%20clues%20and%20city%20nocturnal%20silhouette%2C%20mystery%20manga%20cover%2C%20dark%20teal%20and%20amber%20tones%2C%20intricate%20comic%20art&width=640&height=900&seq=mm-comic-yexing&orientation=portrait",
    desc: "只能在夜晚行动的神探，白天是普通图书管理员，夜晚则穿梭于罪案现场，用缜密的推理还原每一个被掩埋的真相。",
  },
  {
    id: "canghai-liuxing",
    title: "沧海流星",
    category: "国漫",
    categoryId: "manhua",
    status: "连载中",
    score: "9.0",
    readers: "59万",
    chapter: "第 142 话",
    tags: ["国漫", "神话", "冒险"],
    cover: "https://readdy.ai/api/search-image?query=a%20mythical%20adventurer%20riding%20a%20meteor%20across%20a%20starlit%20ocean%20sky%2C%20chinese%20mythology%20adventure%20manga%20cover%2C%20deep%20indigo%20and%20gold%20palette%2C%20magical%20epic%20atmosphere%2C%20comic%20art&width=640&height=900&seq=mm-comic-canghai&orientation=portrait",
    desc: "取材自中国神话传说的冒险史诗，少年流星使者穿越沧海与星海，收集散落人间的星辰之力，重燃消逝的神话。",
  },
];

export const collections = [
  {
    id: "coll-wuxia",
    title: "武侠热血合集",
    count: "128 部",
    desc: "刀光剑影的江湖世界，一网打尽经典与爆款武侠漫。",
    tag: "人气",
    image: "https://readdy.ai/api/search-image?query=epic%20wuxia%20martial%20arts%20showdown%20scene%20with%20swordsmen%20clashing%20on%20a%20rooftop%20under%20the%20moon%2C%20chinese%20jianghu%20landscape%2C%20dynamic%20action%2C%20cinematic%20manga%20collection%20banner%20art&width=900&height=600&seq=mm-coll-wuxia&orientation=landscape",
  },
  {
    id: "coll-gufeng",
    title: "古风权谋合集",
    count: "86 部",
    desc: "庙堂江湖两相宜，沉浸式古风权谋佳作合集。",
    tag: "口碑",
    image: "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20intrigue%20scene%20with%20pagodas%20and%20cherry%20blossoms%20at%20sunset%2C%20elegant%20gufeng%20aesthetic%2C%20ink%20wash%20and%20gold%2C%20cinematic%20manga%20collection%20banner%20art&width=900&height=600&seq=mm-coll-gufeng&orientation=landscape",
  },
  {
    id: "coll-kehuan",
    title: "星际科幻合集",
    count: "64 部",
    desc: "星辰大海的浪漫与硬核，探索无限可能的宇宙。",
    tag: "热门",
    image: "https://readdy.ai/api/search-image?query=majestic%20starship%20fleet%20flying%20through%20a%20colorful%20galaxy%20nebula%2C%20sci-fi%20space%20battle%2C%20vibrant%20nebula%20colors%2C%20cinematic%20manga%20collection%20banner%20art&width=900&height=600&seq=mm-coll-kehuan&orientation=landscape",
  },
  {
    id: "coll-meishi",
    title: "美食治愈合集",
    count: "52 部",
    desc: "暖胃更暖心，治愈系美食漫一天心情都变好。",
    tag: "治愈",
    image: "https://readdy.ai/api/search-image?query=cozy%20steaming%20gourmet%20food%20spread%20on%20a%20wooden%20table%20with%20warm%20light%2C%20heartwarming%20culinary%20manga%2C%20soft%20golden%20tones%2C%20cinematic%20food%20collection%20banner%20art&width=900&height=600&seq=mm-coll-meishi&orientation=landscape",
  },
  {
    id: "coll-manghua",
    title: "国漫巅峰合集",
    count: "96 部",
    desc: "国产佳作巅峰之作，见证国漫崛起的每一刻。",
    tag: "精选",
    image: "https://readdy.ai/api/search-image?query=bold%20chinese%20anime%20character%20group%20heroic%20pose%20in%20front%20of%20a%20vibrant%20mountain%20backdrop%2C%20donghua%20collection%20banner%2C%20strong%20primary%20colors%2C%20energetic%20comic%20art&width=900&height=600&seq=mm-coll-manghua&orientation=landscape",
  },
  {
    id: "coll-xuanyi",
    title: "悬疑烧脑合集",
    count: "58 部",
    desc: "层层反转的烧脑谜局，悬疑控的天堂一次性补全。",
    tag: "口碑",
    image: "https://readdy.ai/api/search-image?query=dark%20mysterious%20detective%20scene%20with%20moonlight%20and%20scattered%20clues%20on%20a%20desk%2C%20suspense%20manga%20collection%2C%20moody%20noir%20teal%20and%20amber%2C%20cinematic%20banner%20art&width=900&height=600&seq=mm-coll-xuanyi&orientation=landscape",
  },
];

export const updates = [
  { title: "剑起沧澜", chapter: "第 258 话 · 风云再起", time: "10 分钟前", type: "更新", tag: "热血" },
  { title: "都市隐龙", chapter: "第 342 话 · 暗流涌动", time: "32 分钟前", type: "更新", tag: "都市" },
  { title: "灵狐传", chapter: "第 221 话 · 仙缘初现", time: "1 小时前", type: "更新", tag: "玄幻" },
  { title: "食戟之战", chapter: "第 236 话 · 终局对决", time: "2 小时前", type: "更新", tag: "美食" },
  { title: "暗夜猎手", chapter: "第 167 话 · 迷雾重重", time: "3 小时前", type: "更新", tag: "悬疑" },
  { title: "山河绘卷", chapter: "第 203 话 · 棋局落子", time: "5 小时前", type: "更新", tag: "古风" },
  { title: "元界使者", chapter: "第 178 话 · 异能觉醒", time: "6 小时前", type: "更新", tag: "异能" },
  { title: "校园奇缘", chapter: "第 158 话 · 心动时刻", time: "8 小时前", type: "更新", tag: "校园" },
];

export const faqs = [
  {
    q: "漫漫漫画上的漫画需要付费才能看吗？",
    a: "漫漫漫画聚合了海量漫画全集，大部分作品都可以直接在线免费阅读。部分受版权保护的热门连载，会根据作品方要求提供试读或会员章节，具体以每部作品页面标注为准。",
  },
  {
    q: "如何快速找到我想看的漫画？",
    a: "你可以在首页顶部的搜索框输入作品名，也可以通过分类目录按热血、都市、玄幻、科幻、悬疑等题材筛选，还能从热门合集和最新更新中浏览发现新作品，找漫不迷路。",
  },
  {
    q: "收藏的漫画更新了会通知我吗？",
    a: "当你收藏或追更某部漫画后，首页的「我的追更」会显示该作品的最新更新进度，并按照更新顺序排列，让你第一时间掌握每一话的最新动态。",
  },
  {
    q: "漫画可以离线阅读或缓存吗？",
    a: "支持的。打开作品阅读页后，点击章节右上角的下载按钮即可缓存当前章节，在无网络环境下也能随时翻阅，方便你通勤或旅途中阅读。",
  },
  {
    q: "漫漫漫画的更新频率如何？",
    a: "热门连载作品通常每周更新 1-3 话，完结作品则一次性放出全部章节。首页的「最新更新」板块实时同步各作品的更新动态，方便你及时追更。",
  },
  {
    q: "遇到无法观看或加载失败怎么办？",
    a: "建议先检查网络连接或尝试切换清晰度。若仍无法加载，可点击页面底部的「联系我们」反馈具体作品和章节，我们会尽快排查处理，为你提供流畅的阅读体验。",
  },
];

export const stats = [
  { value: "12000+", label: "收录漫画" },
  { value: "860+", label: "热门合集" },
  { value: "320万+", label: "每日读者" },
  { value: "48万+", label: "追更人次" },
];